import { render } from "./searchResults.vue?vue&type=template&id=b022cce0&scoped=true"
import script from "./searchResults.vue?vue&type=script&lang=js"
export * from "./searchResults.vue?vue&type=script&lang=js"

import "./searchResults.vue?vue&type=style&index=0&id=b022cce0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b022cce0"]])

export default __exports__